import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { SoccerBall } from "@phosphor-icons/react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setError("Missing session_id");
      return;
    }

    (async () => {
      try {
        const { data } = await apiClient.post("/auth/google/exchange", { session_id: sessionId });
        setSession(data.token, data.user);
        // Clear the hash from URL for cleanliness
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.user.name?.split(" ")[0] || "Predictor"}`);
        navigate("/fixtures", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Sign-in failed");
      }
    })();
  }, [navigate, setSession]);

  return (
    <div className="min-h-[60vh] grid place-items-center px-4">
      <div className="text-center">
        <SoccerBall size={40} weight="fill" className="text-primary-yellow mx-auto animate-spin" />
        <p className="mt-4 text-xs uppercase tracking-[0.3em] text-white/50">
          {error ? "Sign-in failed" : "Signing you in via Google…"}
        </p>
        {error && (
          <div className="mt-4">
            <p className="text-red-400 text-sm">{error}</p>
            <button
              onClick={() => navigate("/login")}
              className="mt-4 border border-white/20 px-6 py-2 text-xs uppercase tracking-widest hover:border-primary-yellow hover:text-primary-yellow"
            >Back to Login</button>
          </div>
        )}
      </div>
    </div>
  );
}
